import React from 'react';

import {IDefaultModalOpenerFormListProps} from 'components/report-configuration/report-configuration.types';
import {IconFormatSettingsModalOpener} from 'components/report-configuration/tabs/report-table-settings/modals/icon-format-settings-modal-opener';
import {SwitchFormatSettingsModalOpener} from 'components/report-configuration/tabs/report-table-settings/modals/switch-format-settings-modal-opener';
import {TCustomColumnType} from 'store/slices/report-configuration-slice/report-configuration-dto';

interface ITypeDependentFormatSettingsModalOpenerProps extends IDefaultModalOpenerFormListProps {
    type: TCustomColumnType | undefined;
}

export const TypeDependentFormatSettingsModalResolver = (props: ITypeDependentFormatSettingsModalOpenerProps) => {
    const {type} = props;

    return (
        <>
            {
                (() => {
                    switch (type) {
                    case 'ICON': {
                        return (
                            <IconFormatSettingsModalOpener
                                {...props}
                            />
                        );
                    }
                    case 'SWITCH': {
                        return (
                            <SwitchFormatSettingsModalOpener
                                {...props}
                            />
                        );
                    }
                    default:
                        return null;
                    }
                })()
            }
        </>
    );
};
